// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SortDescendingOutlinedSvg from "@ant-design/icons-svg/es/asn/SortDescendingOutlined";
import AntdIcon from '../components/AntdIcon';

var SortDescendingOutlined = function SortDescendingOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SortDescendingOutlinedSvg
  }));
};

SortDescendingOutlined.displayName = 'SortDescendingOutlined';
export default React.forwardRef(SortDescendingOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SortDescendingOutlined.js
// module id = 1853
// module chunks = 0